import { render, staticRenderFns } from "./MaterialTemplateEditPage.vue?vue&type=template&id=76da5f64&scoped=true"
import script from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplateEditPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplateEditPage.vue?vue&type=style&index=0&id=76da5f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76da5f64",
  null
  
)

export default component.exports